/* unplugin-vue-components disabled */import script from "./GoodsStockManager.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsStockManager.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__